import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router';
import AssignmentSubmission from '../components/AssignmentSubmission/AssignmentSubmission';
import {
  getQueryParams,
  getReturnUrlAndRestOfQueryParams,
} from '../helpers/url';
import assignmentTypes from '../utils/assignmentTypes';

const getAssignmentParams = assignmentType => {
  const history = useHistory();
  const { assignmentInstanceId } = useParams();
  const { classId, mloId, samePage } = getQueryParams(history);

  let assignmentParams = null;

  switch (assignmentType) {
    case assignmentTypes.TEACHER:
      assignmentParams = {
        assignmentInstanceId,
        classId,
        mloId,
        samePage,
      };
      break;
    case assignmentTypes.ALEF:
      assignmentParams = {
        classId,
        mloId,
      };
      break;

    default:
      throw new Error('assignmentType is not valid');
  }

  return assignmentParams;
};

const AssignmentSubmissionPage = ({ assignmentType }) => {
  const history = useHistory();
  const returnUrl = getReturnUrlAndRestOfQueryParams();
  const { isGradableItemsLockedByDefault } = getQueryParams(history);
  const { assignmentId, studentId } = useParams();

  const onGoBack = () => {
    history.goBack();
  };

  const onSaveOrSubmit = operation => {
    if (returnUrl) {
      window.location.href = `${
        window.location.origin
      }${returnUrl}?assignmentSuccessfulAction=${operation}`;
    }

    window.location.reload();
  };

  return (
    <AssignmentSubmission
      studentId={studentId}
      assignmentId={assignmentId}
      isGradableItemsLockedByDefault={isGradableItemsLockedByDefault === 'true'}
      assignmentType={assignmentType}
      teacherAssignmentParams={
        assignmentType === assignmentTypes.TEACHER
          ? getAssignmentParams(assignmentType)
          : undefined
      }
      alefAssignmentParams={
        assignmentType === assignmentTypes.ALEF
          ? getAssignmentParams(assignmentType)
          : undefined
      }
      onGoBack={onGoBack}
      onSaveOrSubmit={onSaveOrSubmit}
    />
  );
};

export default AssignmentSubmissionPage;

AssignmentSubmissionPage.propTypes = {
  assignmentType: PropTypes.string.isRequired,
};
